import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, Video, Home, MessageCircle, MapPin, ChevronRight, Clock } from 'lucide-react';
import { mockAppointments } from '../data/mockData';
export function AppointmentsScreen() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'upcoming' | 'completed' | 'cancelled'>('upcoming');
  const filteredAppointments = mockAppointments.filter(app => app.status === activeTab);
  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'Video':
        return <Video className="w-4 h-4" data-id="element-100" />;
      case 'Home Visit':
        return <Home className="w-4 h-4" data-id="element-101" />;
      case 'Clinic':
        return <MapPin className="w-4 h-4" data-id="element-102" />;
      case 'Chat':
        return <MessageCircle className="w-4 h-4" data-id="element-103" />;
      default:
        return <Calendar className="w-4 h-4" data-id="element-104" />;
    }
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col h-full bg-slate-50 pb-20" data-id="element-105">
      <div className="bg-white px-6 pt-12 pb-4 shadow-sm z-10 sticky top-0" data-id="element-106">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-107">Appointments</h1>
      </div>

      <div className="px-6 py-4" data-id="element-108">
        <div className="flex bg-slate-100 p-1 rounded-xl mb-6" data-id="element-109">
          {(['upcoming', 'completed', 'cancelled'] as const).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`flex-1 py-2 text-sm font-medium rounded-lg capitalize transition-colors ${activeTab === tab ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-110">
              {tab}
            </button>)}
        </div>

        <div className="space-y-4" data-id="element-111">
          {filteredAppointments.length > 0 ? filteredAppointments.map(appointment => <div key={appointment.id} className="bg-white p-4 rounded-2xl shadow-sm border border-slate-100" data-id="element-112">
                <div className="flex items-start gap-4 mb-4" data-id="element-113">
                  <img src={appointment.professionalImage} alt={appointment.professionalName} className="w-12 h-12 rounded-full object-cover" data-id="element-114" />
                  <div className="flex-1" data-id="element-115">
                    <h3 className="font-semibold text-slate-900" data-id="element-116">
                      {appointment.professionalName}
                    </h3>
                    <div className="flex items-center text-sm text-slate-500 mt-1 gap-2" data-id="element-117">
                      <span className="flex items-center gap-1" data-id="element-118">
                        {getTypeIcon(appointment.type)}
                        {appointment.type}
                      </span>
                      <span data-id="element-119">•</span>
                      <span className="flex items-center gap-1" data-id="element-120">
                        <Clock className="w-3 h-3" data-id="element-121" />
                        {appointment.date}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex gap-2 pt-3 border-t border-slate-100" data-id="element-122">
                  {activeTab === 'upcoming' && <>
                      {appointment.type === 'Video' ? <button onClick={() => navigate('/video-waiting')} className="flex-1 bg-blue-600 text-white py-2 rounded-xl font-medium text-sm" data-id="element-123">
                          Join Call
                        </button> : appointment.type === 'Chat' ? <button onClick={() => navigate('/chat/active')} className="flex-1 bg-blue-600 text-white py-2 rounded-xl font-medium text-sm" data-id="element-124">
                          Open Chat
                        </button> : <button className="flex-1 bg-blue-600 text-white py-2 rounded-xl font-medium text-sm" data-id="element-125">
                          Get Directions
                        </button>}
                      <button className="flex-1 bg-slate-100 text-slate-700 py-2 rounded-xl font-medium text-sm" data-id="element-126">
                        Reschedule
                      </button>
                    </>}
                  {activeTab === 'completed' && <>
                      <button onClick={() => navigate('/visit-summary')} className="flex-1 bg-slate-100 text-slate-700 py-2 rounded-xl font-medium text-sm" data-id="element-127">
                        View Summary
                      </button>
                      <button onClick={() => navigate('/rating')} className="flex-1 bg-blue-50 text-blue-600 py-2 rounded-xl font-medium text-sm" data-id="element-128">
                        Rate Visit
                      </button>
                    </>}
                  {activeTab === 'cancelled' && <button className="w-full bg-blue-600 text-white py-2 rounded-xl font-medium text-sm" data-id="element-129">
                      Rebook
                    </button>}
                </div>
              </div>) : <div className="text-center py-12" data-id="element-130">
              <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-131">
                <Calendar className="w-8 h-8 text-slate-400" data-id="element-132" />
              </div>
              <h3 className="text-lg font-medium text-slate-900 mb-1" data-id="element-133">
                No {activeTab} appointments
              </h3>
              <p className="text-slate-500 text-sm" data-id="element-134">
                When you book a consultation, it will appear here.
              </p>
            </div>}
        </div>
      </div>
    </motion.div>;
}